import React from 'react';
import { MdVideocam, MdPerson } from 'react-icons/md';
import styled from 'styled-components';

const DoctorSlot = styled.div`
  display: flex;
  align-items: center;
`;

const DoctorSlots = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: '1rem',
        marginTop: '10px'
      }}
    >
      <DoctorSlot>
        <MdPerson />
        &nbsp; <span style={{ fontSize: '0.8rem' }}>In-Person Slot</span>
      </DoctorSlot>
      <DoctorSlot>
        <MdVideocam />
        &nbsp; <span style={{ fontSize: '0.8rem' }}>VC Slot</span>
      </DoctorSlot>
      <DoctorSlot>
        <span>
          <MdPerson />/<MdVideocam />
        </span>
        &nbsp; <span style={{ fontSize: '0.8rem' }}>In-Person & VC Slot</span>
      </DoctorSlot>
    </div>
  );
};

export default DoctorSlots;
